import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {ReactComponent as SadFace} from '../../../assets/new-icons/tradizionaleFace.svg';
import { useSelector } from 'react-redux';

function Tradizionale() {
    const navigate = useNavigate()
    const selectorUser = useSelector((user) => user.user);
    const saldoNegativo = selectorUser.nuoviDatiContratto.mono_negativo;

  return (
    <div className='infoBox boxInfo' onClick={() => navigate('/enrica/il-tuo-piano')}>
        <div className="customRow">
            <div className={`icon red`}>
                <SadFace />
            </div>
            {/* In test si vedrà sempre verde perché ho l'offerta dipendenti */}
            <p className="tipologia">Puoi avere un prezzo migliore!</p>
            <div className="arrow">
                <ArrowForwardIosIcon />
            </div>
        </div>
        <div className="customRow">
            <div className="empty"></div>
            <div className="columnCard">
                <p className="paghi">
                    Paghi in maniera tradizionale, alla scadenza dei consumi.
                    Il totale da pagare è calcolato al prezzo di listino standard.
                </p>
                <p className="price red">PUN + Spread + 0,05€</p>
            </div>
        </div>
    </div>
  );
}

export default Tradizionale;
